import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HomeIntro from "../components/Home/HomeIntro";
import SectorMarquee from "../components/Home/SectorMarquee";
import StatsBand from "../components/Home/StatsBand";
import About from "../components/Home/About";
import Services from "../components/Home/Services";
import WhyUs from "../components/Home/WhyUs";
import SectorsGrid from "../components/Home/SectorsGrid";
import ProcessSteps from "../components/Home/ProcessSteps";
import Book from "../components/Home/Book";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <HomeIntro />
      <SectorMarquee />
      <StatsBand />
      <About />
      <Services />
      <WhyUs />
      <SectorsGrid />
      <ProcessSteps />
      <Book />
      <Footer />
    </Box>
  );
};

export default Home;
